import { createFetch, accept, header, init } from 'http-client'

export default (url, options = {}) => {
  const request = createFetch(
    accept('application/json'),
    header('x-requested-with', 'fetch'),
    header('content-type', 'application/json'),
    init('credentials', options.credentials || 'include')
  )

  return request(url, options)
}
